// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64(),
  worldId: __t.u64().name("world_id"),
  heroId: __t.u64().name("hero_id"),
  owner: __t.identity(),
  def: __t.u16(),
  tier: __t.u8(),
  name: __t.string(),
  equippedSlot: __t.option(__t.u8()).name("equipped_slot"),
  relic: __t.bool(),
  bornEvent: __t.option(__t.u64()).name("born_event"),
  acquiredAt: __t.timestamp().name("acquired_at"),
});
